import { API } from 'aws-amplify'

export default async params => {
  return API.post('process', 'datapoints/requestprocessdata', {body: params})
}
